// extracted by mini-css-extract-plugin
export default {"content":"SearchFail_content__irjz5","description":"SearchFail_description__n56QM"};